import login from './login';
import base from './base';
import refreshToken from './refresh-token';

export default {
  ...base,
  ...login,
  refreshToken,
};
